// Scores go from 0 to 10; the color shows at a glance whether it is fine
export const LEVELS = [
  { min: 9, label: "Excelente", color: "#067806", textColor: "#ffffff" },
  { min: 7, label: "Bien", color: "#0ca30c", textColor: "#ffffff" },
  { min: 4, label: "Regular", color: "#fab219", textColor: "#1f2937" },
  { min: 0, label: "Bajo", color: "#d03b3b", textColor: "#ffffff" },
];

export const levelFor = (score: number) =>
  LEVELS.find((level) => score >= level.min)!;

// A perfect score gets a flame; compared rounded, as it is shown on screen
export const isPerfect = (score: number) => score.toFixed(1) === "10.0";
